import _BaseAPIService from "./_BaseAPIService";

  const apiService = _BaseAPIService.instance;
const ServiceModule = {
  getList: async () => {
    const response = await apiService.get("/ourservices");
    return response.data;
  },

  getById: async (id) => {
    const response = await apiService.get(`/ourservices/${id}`);
    return response.data;
  },

  getBySlug: async (id) => {
    const response = await apiService.get(`/ourservices/slug?slug=${id}`);
    return response.data;
  },
    
}

export default ServiceModule
